import _ from 'lodash';

const isEmpty = (string) => {
  return _.isEmpty(_.trim(string));
};

const isEmail = ({ username }) => {
  return username.includes('@');
};

const isEmailString = (username) => {
  return username.includes('@');
};

const isValidEmail = (string) => {
  return /^[a-zA-Z0-9_.-]{1,}@[a-zA-Z0-9_-]{2,}(.[a-zA-Z0-9_-]{2,}){1,}$/.test(string);
};

const isValidPhone = (string) => {
  return /^[0-9]{10}$/.test(string);
};

const isValidCode = (string) => {
  return /^[0-9]+$/.test(string);
};

const isValidColor = (colorHex) => {
  return /^#[a-fA-F0-9]{6}$/.test(colorHex);
};

// @deprecated: use `isValidUsernamePolicy` instead of this
const isValidUsername = (username) => {
  return isValidEmail(username) || isValidPhone(username);
};

const isValidUsernamePolicy = (username, usernamePolicy = {}, allowEmail, allowPhone) => {
  // 1. If no policy provided, fallback to default validation
  if (_.isEmpty(usernamePolicy)) {
    return isValidUsername(username);
  }

  // 2. Check if input is email
  if (allowEmail && isEmailString(username)) {
    return isValidEmailPolicy(username, usernamePolicy.email);
  }

  // 3. Check if input is phone
  if (allowPhone && !isEmailString(username)){
    return isValidPhonePolicy(username, usernamePolicy.phone);
  }

  // 4. No allowed type policy match
  console.log('No allowed type policy match.');
  return false;
};

function isValidPhonePolicy(username, phonePolicy) {
  const { regexValidation } = phonePolicy || {};

  // 1. Use custom regex if provided, otherwise use default validation
  if (regexValidation) {
    const isValid = new RegExp(regexValidation).test(username);
    if (isValid) return true; // case valid

    // case invalid
    console.log(`Username ${username} does not match phone regex pattern: ${regexValidation}`);
    return false;
  }

  // 2. Default validation is using isValidPhone()
  return isValidPhone(username);
}

function isValidEmailPolicy(username, emailPolicy) {
  // 1. Get domain from email
  const { allowedDomains, regexValidation } = emailPolicy || {};
  const domain = username.split('@')[1];

  // 2. Validate against allowed domains if they exist
  if (allowedDomains && allowedDomains.length > 0) {
    if (!allowedDomains.includes(domain)) {
      console.log(`Domain ${domain} is not allowed. Allowed domains:`, allowedDomains);
      return false;
    }
  }

  // 3. Use custom regex if provided, otherwise use default validation
  if (regexValidation) {
    const isValid = new RegExp(regexValidation).test(username);
    if (isValid) return true; // case valid

    // case invalid
    console.log(`Username ${username} does not match email regex pattern: ${regexValidation}`);
    return isValid;
  }

  // 4. Default validation is using isValidEmail()
  return isValidEmail(username);
}

const defaultPasswordPolicy = {
  minLength: 6,
  uppercase: 0,
  number: 0,
  special: 0,
};

const isValidPassword = (password, passwordPolicy = { minLength: 6 }) => {
  const { minLength, uppercase, number, special } = passwordPolicy;

  if (minLength && password.length < minLength) return false;

  if (uppercase && uppercase > 0) {
    let countUppercase = 0;
    for (const ch of password) {
      if (ch.toUpperCase() === ch) {
        countUppercase++;
      }
    }
    if (countUppercase < uppercase) return false;
  }

  if (number && number > 0) {
    const numberChars = '0123456789';
    let countNumber = 0;
    for (const ch of password) {
      if (numberChars.includes(ch)) {
        countNumber++;
      }
    }
    if (countNumber < number) return false;
  }

  if (special && special > 0) {
    const specialChars = ' !"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~';
    let countSpecial = 0;
    for (const ch of password) {
      if (specialChars.includes(ch)) {
        countSpecial++;
      }
    }
    if (countSpecial < special) return false;
  }

  return true;
};

export const validator = {
  isEmpty,
  isEmail,
  isValidEmail,
  isValidPhone,
  isValidCode,
  isValidColor,
  isValidUsername,
  isValidUsernamePolicy,
  defaultPasswordPolicy,
  isValidPassword,
};
